import { FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
import { marketingCategories, salesCategories, serviceCategories, webCategories, marketingHubTools, salesHubTools, serviceHubTools, smartCrmHubTools } from 'academy-common-lib/constants/categories';
export const CategoriesSubSections = {
  MARKETING: marketingCategories.slice(),
  SALES: salesCategories.slice(),
  SERVICE: serviceCategories.slice(),
  SERVICE_SUPPORT: serviceCategories.slice(),
  WEB_DESIGN_DEVELOPMENT: webCategories.slice()
};
export const HubspotToolsSubSections = {
  MARKETING_HUB_TOOLS: marketingHubTools.slice(),
  SALES_HUB_TOOLS: salesHubTools.slice(),
  SERVICE_HUB_TOOLS: serviceHubTools.slice(),
  SMART_CRM_HUB_TOOLS: smartCrmHubTools.slice()
};

// Temporary: This will be removed once Smart CRM tools are added to HubSpotSoftwareFilterType and we can use HubspotToolsSubSections instead.
export const HubspotProductToolsSections = {
  MARKETING_HUB_TOOLS: marketingHubTools.filter(filterName => filterName !== 'MARKETING_CRM').slice(),
  SALES_HUB_TOOLS: salesHubTools.filter(filterName => filterName !== 'SALES_CRM').slice(),
  SERVICE_HUB_TOOLS: serviceHubTools.filter(filterName => filterName !== 'SERVICE_HUB_CRM').slice(),
  SMART_CRM_HUB_TOOLS: smartCrmHubTools.slice()
};
export const SEARCH_FILTERS = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.LEVEL, FILTER_TYPES.DURATION, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.LANGUAGE, FILTER_TYPES.CONTENT_SOURCE];